import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

/** One place to change table / list datetime display across the super-admin app. */
export const APP_DATETIME_FORMAT = 'dd MMM yyyy, HH:mm';

@Pipe({
  name: 'appDate',
  standalone: true,
})
export class AppDatePipe implements PipeTransform {
  transform(value: string | Date | number | null | undefined): string {
    if (value == null || value === '') {
      return '—';
    }
    const d = typeof value === 'string' || typeof value === 'number' ? new Date(value) : value;
    if (Number.isNaN(d.getTime())) {
      return '—';
    }
    return formatDate(d, APP_DATETIME_FORMAT, 'en-GB');
  }
}
